export {};

declare global {
  interface ObjectConstructor {
    /**
     * Returns an array containing `'all'` followed by the values of the provided object or enum.
     */
    values_with_all<T extends Record<string, string | number>>(obj: T): string[];

    sort_keys_recursively(value: any): any;
  }
}

function values_with_all<T extends Record<string, string | number>>(obj: T): string[] {
  return ['all', ...Object.values(obj).map(String)];
}

function sort_keys_recursively(value: any): any {
  // Handle null, undefined, or primitive types
  if (value === null || typeof value !== 'object') return value;

  // Handle Arrays: sort objects inside arrays, keep array order
  if (Array.isArray(value)) return value.map(sort_keys_recursively);

  // Handle Plain Objects: sort keys alphabetically
  let out = Object.keys(value)
    .sort()
    .reduce((sorted: Record<string, any>, key) => {
      sorted[key] = sort_keys_recursively(value[key]);
      return sorted;
    }, {});

  return out;
}

export function INIT_EXTENSION__object_static() {
  Object.values_with_all = values_with_all;
  Object.sort_keys_recursively = sort_keys_recursively;
}
